import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/components/common/api';
import { User, UserComplex } from '../../models/user.model';
import { AuthService } from '../../services/user/auth.service';
import { UsersService } from '../../services/user/users.service';

@Component({
  providers: [],
  templateUrl: 'profile.html'
})

export class ProfileComponent {
  constructor(
    private userService: UsersService,
    private translate: TranslateService,
    private srvNotify: MessageService,
    private authService: AuthService
  ) {}

  onChangePasswordSubmit(e, newPassword: HTMLInputElement, confirmPassword: HTMLInputElement): void {
    e.preventDefault();
    if (newPassword.value !== confirmPassword.value) {
      this.translate.get(['login.passwordsNoMatch']).subscribe((res) => {
        this.srvNotify.add({severity:'error', detail:res['login.passwordsNoMatch']});
      });
      return;
    }
    this.userService.changePassword(newPassword.value, confirmPassword.value).subscribe((res) => {
      newPassword.value = '';
      confirmPassword.value = '';
    });
  }

  onChangeEmailSubmit(e, newEmailField): void {
    e.preventDefault();
    var uc = new UserComplex();
    uc.user = new User;
    uc.user.id = this.authService.user.id;
    uc.user.email = newEmailField.value;
    this.userService.put(uc).subscribe(
      (res) => function() {
        console.log("Cambio email richiesto con successo !!!");
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/views/profile/profile.component.ts